import { Tag, Typography } from 'antd';
import styles from './PersonalizationTag.module.scss';

const { Text } = Typography;

interface Props {
  value: string;
}

export function PersonalizationTag(props: Props) {
  const { value } = props;
  return (
    <div className={styles.subtitle}>
      <Tag color="blue">
        <Text>{value}</Text>
      </Tag>
    </div>
  );
}
